import React from 'react';
interface PanelProps {
  title?: string;
  eyebrow?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}
export function Panel({
  title,
  eyebrow,
  action,
  children,
  className = '',
  bodyClassName = ''
}: PanelProps) {
  return <section className={`rounded-2xl border border-ink-700 bg-ink-850 shadow-panel ${className}`} data-id="element-65" data-mp="35f3b5xzl0fqw">
      {(title || action) && <header className="flex items-start justify-between gap-4 border-b border-ink-700/70 px-5 py-4" data-id="element-66" data-mp="3j56q03w4t76b">
          <div data-id="element-67" data-mp="3f3v160l30pz6">
            {eyebrow && <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-faint" data-id="element-68" data-mp="3t4e5awmffbw2">{eyebrow}</p>}
            {title && <h2 className="mt-1 text-[15px] font-semibold tracking-tight text-chalk" data-id="element-69" data-mp="3o4t38dbymnf4">{title}</h2>}
          </div>
          {action}
        </header>}
      <div className={`px-5 py-5 ${bodyClassName}`} data-id="element-70" data-mp="1yshb4vwlnrxb">{children}</div>
    </section>;
}